import { createVNode as r, mergeProps as n } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/PatientFemaleTwotoneStandard.js";
import i from "../components/PfIcon.js";
const t = (e, a) => {
  const o = {
    ...e,
    ...a.attrs
  };
  return r(i, n(o, {
    icon: m
  }), null);
};
t.displayName = "PatientFemaleTwotoneStandard";
t.inheritAttrs = !1;
export {
  t as default
};
